
export function Title()
{
	return 'Venue Online Services (VOS)';
}
